module.exports = __webpack_public_path__ + "img/monitor-bg.22f3ad51.png";